import { render } from "./AdminTable.vue?vue&type=template&id=ee0230d8&scoped=true"
import script from "./AdminTable.vue?vue&type=script&lang=js"
export * from "./AdminTable.vue?vue&type=script&lang=js"

import "./AdminTable.vue?vue&type=style&index=0&id=ee0230d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee0230d8"]])

export default __exports__